import {
  Login,
  ChangePassword,
  ForgotPassword,
  ResetPasswordWithOtp,
} from "@/pages";
import { useRoutes } from "react-router-dom";
import { routes } from "./utils";
import { NotFound } from "@/components";
import { AdminRoutes } from "./AdminRoutes";
import { PMRoutes } from "./ProjectManagerRoutes";

export const Router = () => {
  const element = useRoutes([
    {
      path: routes.root,
      element: <Login />,
    },
    {
      path: routes.login,
      element: <Login />,
    },
    {
      path: routes.changePassword,
      element: <ChangePassword />,
    },
    {
      path: routes.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      path: routes.resetPasswordOtp,
      element: <ResetPasswordWithOtp />,
    },
    AdminRoutes(),
    PMRoutes(),
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return element;
};
